

















import Vue from 'vue'
import Component from 'vue-class-component'
import { AppModule } from '@app/componentlib/src/store/modules/app'
import { IFilterItem } from '@app/componentlib/common/types/JobSearchTypes'

@Component<SearchFilterDropdownMobile>({
  props: {
    chosenArray: Array,
    filterArray: Array
  }
})

export default class SearchFilterDropdownMobile extends Vue {
  /**
   * Props variables
   */
  chosenArray: string[] | undefined
  filterArray: IFilterItem[] | undefined

  /**
   * Component state variables
   */


  /**
   * Lifecycle
   */


  /**
   * Getters
   */
  get t (): any {
    return AppModule.translations
  }

  /**
   * Methods
   */
   clickedItemFilter(item: string) {
    this.$emit('clickedItemFilter', item)
  }

   changeMobileFiltersIsOpen(bool: boolean) {
    this.$emit('changeMobileFiltersIsOpen', bool)
   }

   startSearch() {
    this.$emit('startSearch')
   }

}
